import '../../css/style.scss'
import {EntryShared} from '../../../shared/scripts/EntryShared'
import {Sound} from '../../../shared/scripts/Sound'
import {UICheckoutPageController} from '../../../shared/scripts/ui_checkout/UICheckoutPageController'

void init()

async function init() {
    Sound.loadSounds()
    await EntryShared.initializeEntry()
    new UICheckoutPageController()
    EntryShared.sendPageVisitAnalyticEvent()
}
